module.exports = "/_next/static/images/jennifer-sands-0943d2242412e5727e38d483c3c9fd1b.png";